import { FinancialAccountType } from "../types/financialAccount";
import { fromMonetaryToInt } from "./monetary";

interface DoesBalancesAndTransactionsReconcileParams {
    openingBalance: number;
    closingBalance: number;
    moneyIn: number;
    moneyOut: number;
    financialType: FinancialAccountType;
}

export function doesBalancesAndTransactionsReconcile({
    closingBalance,
    openingBalance,
    moneyIn,
    moneyOut,
    financialType,
}: DoesBalancesAndTransactionsReconcileParams) {
    const isLiability =
        financialType === FinancialAccountType.LOAN ||
        financialType === FinancialAccountType.CREDIT_CARD;

    if (isLiability) {
        moneyOut = -moneyOut;
        moneyIn = -moneyIn;
    }

    return (
        fromMonetaryToInt(openingBalance) +
            fromMonetaryToInt(moneyIn) -
            fromMonetaryToInt(moneyOut) ===
        fromMonetaryToInt(closingBalance)
    );
}

export const IMPORTER_TRANSACTIONS_QUEUE = "transactions_import";

export function getImporterReconciliationQueue(financialAccountId: number) {
    return `reconciliation_${financialAccountId}`;
}

export enum ImporterSpreadsheetColumns {
    DATE = "date",
    DESCRIPTION = "description",
    AMOUNT = "amount",
}
